// extracted by mini-css-extract-plugin
export default {"root":"_1lfz4do"};